<nav class="navbar bg-F8F9FB border-0 shadow-0">
  <div class="container-fluid py-2 px-3">
    <!-- Logo -->
    <div class="d-flex align-items-center ms-4">
      <img src="assets/images/logo-sofofa.svg" alt="Logo" />
    </div>
    <!-- Logo Portal Persona -->
    <div class="d-flex align-items-center justify-content-center me-5">
      <img src="assets/images/no-image-user.svg" alt="" class="me-2"/>
      <div class="text-400 text-14 text-nunito text-1D2345 d-none d-sm-block">Juanita Pérez</div>
      <button class="btn p-0 border-0 ms-5" type="button" (click)="logOut()" aria-label="Abrir menú">
        <img src="assets/icons/logout.svg" alt="Menu" />
      </button>
    </div>
  </div>
</nav>

@if (currentPage != 'home') {
  <div class="container-fluid bg-transparent py-3">
    <button (click)="toggleSidebar()" class="btn btn-blue ms-4">
      <span class="text-400 text-14 text-nunito text-FFFFFF">MENÚ</span>
      <img src="assets/icons/hamburguesa.svg" alt="" class="ms-3"/>
    </button>
  </div>
}

<!-- Backdrop -->
<div class="sidebar-backdrop" [class.show]="isSidebarOpen" (click)="closeSidebar()"></div>

<!-- Sidebar -->
<aside class="sidebar custom-sidebar" [class.open]="isSidebarOpen" role="dialog" aria-modal="true"
  aria-labelledby="sidebarTitle">
  <div class="offcanvas-body d-flex flex-column h-100" style="padding: 16px 35px 35px 35px  !important;">

    <!-- Logo -->
    <div class="d-flex align-items-center mb-5">
      <img src="assets/images/logo-sofofa.svg" alt="Logo" />
      <button class="btn-close ms-auto" aria-label="Cerrar" (click)="closeSidebar()"></button>
    </div>

    <!-- Header usuario -->
    <div class="d-flex flex-column align-items-start gap-3">
      <img src="assets/images/no-image-user.svg" alt="" height="31px"/>
      <div class="d-flex flex-column">
        <p class="mb-0 text-montserrat text-800 text-16 text-2A2A59">Juanita Pérez</p>
        <p class="mb-0 text-nunito text-500 text-14 text-1D2345">Relator (a) CENCOSUD S.A.</p>
      </div>
      <hr class="bg-E2E4E5 w-100 mb-0" style="height: 2px;"/>
    </div>

    <!-- Links -->
    <div class="sidebar-links flex-grow-1 d-flex flex-column pt-3">
      @for (item of menuItems; track $index) {
        <div>
          <!-- Item principal -->
          <button
            class="sidebar-link text-nunito text-500 text-18 text-0F0F0F d-flex align-items-center justify-content-between w-100"
            [ngClass]="{'active': currentPage.includes(item.key)}"
            (mouseenter)="item.isHover = true"
            (mouseleave)="item.isHover = false"
            (click)="toggleSubmenu(item)">
            <div class="d-flex align-items-center">
              <img [src]="
                currentPage.includes(item.key) || item.isHover 
                  ? 'assets/icons/' + item.icon + '-active.svg' 
                  : 'assets/icons/' + item.icon + '.svg'
              " class="me-2" width="26" height="26" />
              {{ item.label }}
            </div>
          </button>

          <!-- Subitems -->
           @if (item.subItems && item.isExpanded) {
            <div class="ms-4 mt-2 d-flex flex-column">
              @for (sub of item.subItems; track $index) {
                <button
                  class="sidebar-link text-nunito text-400 text-16 text-0F0F0F d-flex align-items-center"
                  [ngClass]="{'active': currentPage === sub.key}"
                  (mouseenter)="sub.isHover = true"
                  (mouseleave)="sub.isHover = false"
                  (click)="setPage(sub.route)">
                  <img 
                    [src]="
                      currentPage === sub.key || sub.isHover
                        ? 'assets/icons/nav-subitem-active.svg'
                        : 'assets/icons/nav-subitem.svg'
                    " 
                    alt="" class="me-2"
                  />
                  {{ sub.label }}
                </button>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Salir -->
    <button 
      class="sidebar-link text-nunito text-500 text-18 text-0F0F0F pb-0"
      (mouseenter)="isHoverSalir = true"
      (mouseleave)="isHoverSalir = false"
      (click)="setPage('login')">
      <img [src]="
          isHoverSalir 
            ? 'assets/icons/nav-salir-sesion' + '-active.svg' 
            : 'assets/icons/nav-salir-sesion' + '.svg'
        " class="me-2" width="26" height="26" />
      Salir de la sesión
    </button>
  </div>
</aside>